import { render, staticRenderFns } from "./c_address.vue?vue&type=template&id=0941097a&scoped=true"
import script from "./c_address.vue?vue&type=script&lang=js"
export * from "./c_address.vue?vue&type=script&lang=js"
import style0 from "./c_address.vue?vue&type=style&index=0&id=0941097a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0941097a",
  null
  
)

export default component.exports